type GsapLike = {
    registerPlugin: (...plugins: unknown[]) => void;
    fromTo: (target: unknown, from: object, to: object) => unknown;
    set: (target: unknown, vars: object) => unknown;
};

let registered = false;

export function getGsap(): GsapLike | null {
    const w = window as unknown as { gsap?: GsapLike; ScrollTrigger?: unknown };
    if (!w.gsap) return null;
    if (!registered && w.ScrollTrigger) {
        w.gsap.registerPlugin(w.ScrollTrigger);
        registered = true;
    }
    return w.gsap;
}
